import { Component, OnInit, Input } from '@angular/core';
import { NavParams, ModalController } from '@ionic/angular';
import { WebParameterContext } from '../../model/common';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../service/messageclient.service';
declare var app;
@Component({
  selector: 'app-modalpage',
  templateUrl: './modalpage.page.html',
  styleUrls: ['./modalpage.page.scss'],
})
export class ModalpagePage implements OnInit {
  @Input() ConfigName: string;
  @Input() PageName: string;
  @Input() PageTitle: string;
  @Input() Param: any;
  loading: boolean = false;//加载效果
  apiObj = {
    status: false,
    msg: ''
  };//接口状态

  AssistingPeople: any = [];
  systemUserList: any = [];
  systemuserCheckList:any=[];//获取已邀请人
  systemAllUserList:any = [];
  searchValue:any = "";//查询值
  searchPlaceholder:any = "";//查询提示
  constructor(
    public navParams: NavParams,
    public modalController: ModalController,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
  ) {
    // console.log(navParams.get("ConfigName"),navParams.get("PageName"));
  }

  ngOnInit() {
    console.log(this.ConfigName, this.PageName, "init");
    console.log(this.Param, "init");
    this.searchPlaceholder = "姓名或手机号";
    this.BindUser();
  }

  /**
   * 搜索事件
   * @param e 
   */
  serarEvent(e,type:string = 'type'){ 
    if(e.keyCode == 13 || type=='search'){
      // this.LoadDataInfo(1);
      this.searchUser();
    }
  }
  checkItem(item,i){
    let that = this;
    item["isCheck"] = !item["isCheck"];
    that.systemuserCheckList.forEach((ckitem,index)=>{
      if(ckitem["a_ID"]==item["a_ID"]){
        ckitem=item;
      }
    });
    // let _arr = [];
    // this.systemUserList.forEach(item=>{
    //   if(item["isCheck"]){
    //     _arr.push(item);
    //   }
    // })
    // if(!item["isCheck"] && _arr.length >= this.Param["a_PlannedPopulation"]){
    //   that.msg.Alert("添加的协助人数不能超过"+that.Param['a_PlannedPopulation']+"人")
    // }else{
    //   item["isCheck"] = !item["isCheck"];
    // }
  }

  dismissModal() {
    this.modalController.dismiss({
      'modalStatus': false
    });
  }
  comfireModal() {
    let _arr:any = [];
    let _checkAll:any=[];
    
    this.systemuserCheckList.forEach(checkitems=>{
      if(checkitems["isCheck"]){
        _checkAll.push({ "a_ID": checkitems['a_ID'], "name": checkitems['a_ChineseName'] });
      }
    });
    console.log(_checkAll,"配置文件");
    this.systemUserList.forEach(item=>{
      if(item["isCheck"]){
        _arr.push({ "a_ID": item['a_ID'], "name": item['a_ChineseName'] });
      }
    });
    if(_checkAll.length!=_arr.length){
      this.modalController.dismiss({
        'modalStatus':true,
        'info': _checkAll
      });
    }else{
      this.modalController.dismiss({
        'modalStatus':true,
        'info': _arr
      });
    }
    
  }

  searchUser(){
    let that = this;
    if(this.searchValue){
      that.systemUserList = [];
      that.systemAllUserList.forEach(item=>{
        if(item["a_ChineseName"].indexOf(that.searchValue.trim()) > -1){
          that.systemUserList.push(item);
        }
      })
    }else{
      that.systemUserList = that.systemAllUserList;
    }
  }

  /**
   * 获取所以邀请人
   */
  BindUser() {
    const that = this;

    that.loading = false;
    that.apiObj['status'] = false;
    that.apiObj['msg'] = '';

    let _obj = {};
    const PageName = this.PageName;
    const id = this.Param.id;
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    body.ConfigName = "SystemUser";
    _obj["uar_OpType"] = "ADD";
    _obj["a_FK_TBActivity_ID"] = id;
    _obj["u_ID"] = that.com.GetAccount.Id;
    body.OpType = "query";
    body.ConfigType = "view";
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.ClientType = 2;
    body.RequestBody = JSON.stringify(_obj);
    that.http.post(app.DEFAULTURL, body).then(data => {
      if (data.ResponseMessage.Success) {
        that.systemUserList = data.Status.Datas;
        that.systemuserCheckList = data.Status.Datas;
        that.systemAllUserList = data.Status.Datas;
        this.getSystemUserList();//已邀请人
      } else {
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
        // that.msg.Alert(data.ResponseMessage.ErrorMessage);
      }
    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = "网络繁忙，请稍后再试！";
      that.loading = true;
      console.log(error);
    });
  }

  /**
 * 已邀请协助人
 */
  getSystemUserList() {
    const that = this;

    that.loading = false;
    that.apiObj['status'] = false;
    that.apiObj['msg'] = '';

    let _obj = {};
    const PageName = this.PageName;
    const id = this.Param.id;
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    body.ConfigName = "SystemUserActivityRelation";
    _obj["a_FK_TBActivity_ID"] = id;
    body.OpType = "query";
    body.ConfigType = "view";
    // body.RowsPerPage = app.RowsPerPage; 
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.ClientType = 2;
    body.RequestBody = JSON.stringify(_obj);
    that.http.post(app.DEFAULTURL, body).then(data => {
      that.apiObj['status'] = data.ResponseMessage.Success;
      that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
      that.loading = true;
      if (data.ResponseMessage.Success) {
        that.systemuserCheckList=[];
        that.AssistingPeople = [];
        that.systemUserList.forEach((item, index) => {
          item["isCheck"] = false;
          data.Status.Datas.forEach(val => {
            if (item['a_ID'] == val["bs_ID"]) {
              // if (JSON.stringify(that.AssistingPeople).indexOf(item['a_ID']) == -1) {
              //   item["isCheck"] = true;
              //   that.AssistingPeople.push({ "a_ID": item['a_ID'], "name": item['a_ChineseName'] });
              // }
              item["isCheck"] = true;
            }
          });
        });
        that.systemuserCheckList=that.systemUserList;
      }
    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = "网络繁忙，请稍后再试！";
      that.loading = true;
      console.log(error);
    });
  }
}
